
import clientCustomerFullcont       from "./clientCustomer-fullcont.html";

const dialog          = require ('../../../../../components/dialog/dialog')
const fullcontEntity  = require ('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require ('../../../../../components/fullcont/fullcont-handler')

const {formCopy}      = require('./clientCustomer-fullcont-form') 
const {form}          = require('./clientCustomer-fullcont-form')
const handler         = require('./clientCustomer-fullcont-handler')
const settings        = require('../../../../../js-handler/settings')
// const {clientCustomerMT}      = require('./clientCustomer-fullcont-multitable')

//const clientCustomerMT        = undefined //no MT just add this like undefined

/****************ELEMENTS*****************/
var htmlFc          = {}
var HTMLwasSelected = false

function HTMLselect(detail){ 

	fullcontHandler.HTMLselect(
            'customer','clientCustomer', 'clientCustomer-fullcont', 
            clientCustomerFullcont, form, formCopy, undefined, 
            editDialog, deleteDialog, undefined, htmlFc)

	HTMLwasSelected   = true             
}/**/




export function start(detail){  //console.log('clientCustomer-fullcont >', detail)
  
      if(!HTMLwasSelected) { HTMLselect(detail) }
       
      obj[detail.act].start(detail)
}/**/


const obj = {

      cancelEdit:           { start: (detail)=>{  fullcontEntity.cancelEdit(detail, htmlFc)                }},
      deleteEntity:         { start: (detail)=>{  fullcontEntity.deleteEntity(detail, htmlFc)              }},
      deleteFromDialog:     { start: (detail)=>{  fullcontEntity.deleteFromDialog(detail, htmlFc)          }},
      discard:              { start: (detail)=>{  fullcontHandler.discard(detail, htmlFc)                  }},
      hide:                 { start: (detail)=>{  fullcontEntity.hide(detail, htmlFc)                      }},
      prepareEdit:          { start: (detail)=>{  fullcontHandler.prepareEdit(detail, htmlFc)              }},
      saveFromDialog:       { start: (detail)=>{  fullcontEntity.saveFromDialog(detail, htmlFc)            }},
      selectOne:            { start: (detail)=>{  fullcontEntity.selectOne(detail, htmlFc)                 }},
      update:               { start: (detail)=>{  fullcontEntity.update(detail, htmlFc)                    }},
      show  :               { start: (detail)=>{  htmlFc.fullcontHTML.classList.add('fullcont-show')       }},
      addBillingToShipping: { start: (detail)=>{  handler.addBillingToShipping(detail, htmlFc)             }},

      

      //fullcontOptions:  { start: (detail)=>{  clientCustomerMenu.start(detail, 'htmlDt', htmlFc )                }},

}/**/






//function to send
function editDialog(){
		dialog.start({ act:"show", id:"saveChanges", entity:'clientCustomer' } )
}

function deleteDialog(detail){
		dialog.start({ act:"show", id:"deleteElem", entity:'clientCustomer', dbid: detail.dbid } )
}

// function dtCall(act, result){ 
// 		clientCustomerDt.start({act:act, row: result})
// }


